// extracted by css-extract-rspack-plugin
export default {"SearchContainer":"Search-module__SearchContainer__O_2rw"};